import { errorMessages } from "../constants";
import { sharedDefaultOptions } from "../constants/sharedDefaultOptions";
import {
  Optimizely,
  OnSendError,
  OnSendSuccess,
  PulseEventDispatcher,
} from "../typings";
import { createBatchedPulseEvents } from "./createBatchedPulseEvents";
import { getCollectorUrlFromOptions } from "./getCollectorUrlFromOptions";
import { errorToString } from "../utils";

const POST_METHOD = "POST";

export const genericPulseEventDispatcher: PulseEventDispatcher = (
  providerId,
  initialOptions = {}
) => {
  if (!providerId) {
    throw new Error(errorMessages.PROVIDER_ID_REQUIRED);
  }
  const options = { ...sharedDefaultOptions, ...initialOptions };
  const url = getCollectorUrlFromOptions(options);

  if (!options.sendEventHandler) {
    throw new Error("No sendEventHandler defined");
  }
  const { sendEventHandler } = options;

  return {
    dispatchEvent: (eventObj: Optimizely.EventObject, callback) => {
      if (eventObj.httpVerb !== POST_METHOD) {
        options.logger({
          type: "warn",
          message: `Http method ${eventObj.httpVerb} not supported. Expected 'POST'.`,
        });
        return;
      }

      const body = createBatchedPulseEvents(providerId, eventObj, options);
      const dataString = JSON.stringify(body);

      const onSuccess: OnSendSuccess = (response) => {
        try {
          if (response && callback && typeof callback === "function") {
            callback(response);
          }
        } catch (error) {
          onError(error);
        }
      };

      const onError: OnSendError = (error) => {
        options.logger({
          type: "error",
          message: `Could not POST: ${errorToString(error)}`,
        });
      };

      sendEventHandler(url, dataString, onSuccess, onError);
    },
  };
};
